import { Flex, FlexProps, css, styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { StyledQuickAddFormBox } from './components/QuickAddForm/QuickAddForm.styles';
export const StyledProductTileContainer = styled.div<{ $isactive: boolean; $height?: number }>`
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0;
  ${props =>
    props.$isactive &&
    css`
      -webkit-box-pack: justify;
      justify-content: space-between;
      position: relative;
      top: -1.5rem;
      left: -2rem;
      width: calc(100% + 4rem);
      height: ${props.$height ? props.$height + 'px' : '100%'};
      padding: 0;
      z-index: 8;

      &::before {
        /* 1.5rem to handle top: -2rem from container above +  50% default top for the base column divider */
        top: calc(50% + 1.5rem) !important;

        /* 2rem to handle left: -2rem from the container above + pxToRem(-32) default right for the base column divider */
        right: calc(2rem + ${pxToRem(-32)}) !important;

        ${props => props.theme.mediaQueries.down({ breakpointAlias: 'sm2' })} {
          /* 2rem to handle left: -2rem from the container above + pxToRem(-1 * ((8 - 1) / 2 + 1)) default right for the base column divider */
          right: calc(2rem + ${pxToRem(-1 * ((8 - 1) / 2 + 1))}) !important;
        }
      }

      &::after {
        /* -1.5rem from container above + pxToRem(-32) default bottom for the base row divider */
        bottom: calc(-1.5rem + ${pxToRem(-32)}) !important;

        /* opposite of left: -2rem from container above */
        left: 2rem;

        /* opposite of width: calc(100% + 4rem) from container above */
        width: calc(100% - 4rem) !important;

        ${props => props.theme.mediaQueries.down({ breakpointAlias: 'sm2' })} {
          /* -1.5rem from container above + pxToRem(--8) default bottom for the base row divider */
          bottom: calc(-1.5rem + ${pxToRem(-8)}) !important;
        }
      }
    `}
`;

export const ProductTileContentContainer = styled(Flex)<FlexProps & { $isactive: boolean }>`
  flex-direction: column;
  position: relative;
  align-items: center;
  ${props =>
    props.$isactive &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      padding-left: 2rem;
      padding-right: 2rem;
      padding-top: 1.5rem;
      padding-bottom: 0;
      z-index: 10;
      background: white;
      box-shadow: rgb(0 0 0 / 23%) 0px 10px 30px 0px;
      border-radius: 8px;

      ${StyledQuickAddFormBox} {
        display: block;
        background-color: rgb(255, 255, 255);
        padding: 0 0 1.5rem;
        width: 100%;
      }
    `}
`;

export const ProductTileContainerSkeleton = styled(Flex)<{ isMobile?: boolean }>`
  flex-direction: column;
  position: relative;
  align-items: center;
  min-height: 100%;
`;
